import { PayloadAction } from "@reduxjs/toolkit";
import { GuaranteeDto } from "api/pricing";
import { ContractFunnel } from "features/subscription-process/pricing-process/types/interfaces";
import { PricingState } from "../pricingSlice";
import { createContractFunnelHash } from "../utils/createContractFunnelHash";

export const guaranteesReducers = {
  updateContractFunnelGuarantees: (
    state: PricingState,
    action: PayloadAction<{
      contractFunnelId: string;
      contractIdentifier?: string;
      newGuarantees: GuaranteeDto[];
    }>
  ) => {
    const { contractFunnelId, contractIdentifier, newGuarantees } = action.payload;

    // Chercher si l'item existe déjà dans updatedContractFunnels
    let existingUpdatedIndex = state.updatedContractFunnels.findIndex(
      ucf => ucf.id === contractFunnelId && ucf.contractIdentifier === contractIdentifier
    );

    let targetContractFunnel: ContractFunnel;

    if (existingUpdatedIndex !== -1) {
      // Utiliser l'existant dans updatedContractFunnels
      targetContractFunnel = state.updatedContractFunnels[existingUpdatedIndex];
    } else {
      // Chercher dans contractFunnels et créer une copie
      const originalContractFunnel = state.contractFunnels.find(
        cf => cf.id === contractFunnelId && cf.contractIdentifier === contractIdentifier
      );

      if (!originalContractFunnel) {
        console.error(`ContractFunnel with id ${contractFunnelId} and contract identifier ${contractIdentifier} not found`);
        return;
      }

      // Créer une copie profonde pour éviter les mutations
      targetContractFunnel = {
        ...originalContractFunnel,
        variables: originalContractFunnel.variables.map(v => ({ ...v })), // Copie profonde
        fees: originalContractFunnel.fees ? originalContractFunnel.fees.map(f => ({ ...f })) : undefined, // Copie profonde
        guarantees: originalContractFunnel.guarantees.map(g => ({ ...g })), // Copie profonde
      };

      state.updatedContractFunnels.push(targetContractFunnel);
      existingUpdatedIndex = state.updatedContractFunnels.length - 1;
    }

    targetContractFunnel.guarantees = newGuarantees.map(g => ({
      ...g,
      ceiling: g.ceiling ? {
        ...g.ceiling,
        warningMessage: undefined
      } : undefined,
      deductible: g.deductible ? {
        ...g.deductible,
        warningMessage: undefined
      } : undefined,
    }))
    targetContractFunnel.hash = ''
    targetContractFunnel.hash = createContractFunnelHash(targetContractFunnel)

    // Vérifier si le contractFunnel modifié est identique à l'original
    const originalContractFunnel = state.contractFunnels.find(
      cf => cf.id === contractFunnelId && cf.contractIdentifier === contractIdentifier
    );

    if (originalContractFunnel && originalContractFunnel.hash === targetContractFunnel.hash) {
      // Supprimer de updatedContractFunnels si identique à l'original
      state.updatedContractFunnels.splice(existingUpdatedIndex, 1);
    }
  },
}

